<template>
    <div class="container my-5" v-if="prodnuevos.length > 0">
        <div class="row g-3 align-items-stretch">
            <div class="col-lg-8 col-md-7">
                <div class="banner-destacado position-relative overflow-hidden rounded shadow-sm">

                    <img src="img/bannerproductosnuevos.png" class="img-fluid w-100" alt="Soportes de Motor Premium">

                    <div class="text-overlay-gradient"></div>

                    <div class="text-overlay-content">
                        <p class="elegant-text mb-0">NUEVAS INCORPORACIONES CADA 15 DÍAS</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-5">
                <SectionTitle variant="accent" accent-bar title="<strong>Nuevas </strong>incorporaciones" />

                <div class="mini-products-list d-flex flex-column gap-2">

                    <div v-for="(producto, index) in prodnuevos.slice(0, 4)" :key="index"
                        class="mini-card shadow-sm border rounded">
                        <div class="row g-0 align-items-center">
                            <div class="col-4 p-2">
                                <div class="img-container-mini">
                                    <img v-if="producto.PicturesUrl && producto.PicturesUrl[producto.categorias?.[0]?.marcas?.viewimagesprinc ?? 4]"
                                        :src="producto.PicturesUrl[producto.categorias[0].marcas.viewimagesprinc ?? 4].sm"
                                        class="img-mini-fix" :alt="producto.k_parte" loading="lazy" draggable="false" />

                                    <img v-else src="/img/display/Placeholder.png" class="img-mini-fix"
                                        :alt="producto.k_parte" />

                                </div>
                            </div>
                            <div class="col-8 p-2">
                                <div class="mini-card-body">
                                    <h6 class="brand-text mb-0">{{ producto.k_parte }}</h6>
                                    <p class="product-title mb-1 text-truncate">{{ producto.linea }}</p>
                                    <small class="application-text d-block text-muted">{{ formatApp(producto) }}</small>

                                    <!--<div v-if="producto.active_promotion" class="mt-2">
                                        <span class="px-2 py-1 rounded text-white"
                                            style="background: linear-gradient(90deg, #ff7e5f, #feb47b); box-shadow: 0 2px 6px rgba(0,0,0,0.2); font-size: 0.7rem;">
                                            {{ producto.active_promotion.promocion.nombre }}
                                        </span>
                                    </div>-->

                                    <span
                                        v-if="vehiculoSeleccionado?.marca && producto.marcas_resumen?.includes(vehiculoSeleccionado.marca)"
                                        class="text-success"
                                        style="font-size: 0.65rem;font-weight: 700;padding: 4px 8px;display: flex;align-items: center;gap: 4px;">
                                        <i class="fas fa-check-circle"></i> Compatible con tu {{
                                            vehiculoSeleccionado.marca }}
                                    </span>

                                    <router-link :to="{ name: 'detalleProducto', query: { codigo: producto.k_parte } }"
                                        class="btn-view-more d-block p-0 mt-1">
                                        Ver detalles <i class="fas fa-chevron-right small"></i>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <router-link class="boletin-link mt-2" :to="{ name: 'ListBolletin' }"
                        style="text-decoration: none !important;">
                        <div class="mini-card boletin-mini border-0 shadow-sm d-flex align-items-center p-2 rounded">
                            <img src="img/display/pdf.png" alt="PDF" class="mini-pdf-icon me-3" />
                            <div>
                                <h6 class="mb-0 fw-bold">Boletín Completo</h6>
                                <small>Descargar catálogo</small>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SectionTitle from '../../../Complements/Components/Titleseccions.vue';
export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            prodnuevos: [],
            loading: true,
            isDesktop: false
        };
    },

    mounted() {
        this.checkViewport();
        window.addEventListener("resize", this.checkViewport);
        this.llenadatos();
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.checkViewport);
    },

    methods: {
        formatApp(producto) {
            let app = null;

            // 1. Prioridad al nuevo campo de resumen que creamos
            if (Array.isArray(producto.aplicaciones_resumen) && producto.aplicaciones_resumen.length > 0) {
                app = producto.aplicaciones_resumen[0];
            }
            if (!app) return '';

            // Lógica para formatear el año: "2020-2020" -> "(20-20)"
            let yearFormateado = '';
            if (app.year) {
                // Separamos por el guion, quitamos los primeros dos dígitos y volvemos a unir
                yearFormateado = `(${app.year.split('-').map(y => y.toString().slice(-2)).join('-')})`;
            }

            return [
                app.marca,
                app.modelo,
                yearFormateado, // Usamos el año ya procesado
            ]
                .map(v => typeof v === 'string' ? v.trim() : v)
                .filter(v => v && !['-', '–', 'N/A', '()'].includes(v))
                .join(' ');
        },
        checkViewport() {
            this.isDesktop = window.innerWidth >= 992; // breakpoint lg
        },

        llenadatos() {
            this.loading = true;
            axios.get('/api/ProdsNew').then(response => {
                const itemsRaw = response.data.items;

                this.prodnuevos = itemsRaw.map(item => {
                    return item.producto ? item.producto : item;
                });
            })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    computed: {
        vehiculoSeleccionado() {
            return this.$store.getters.vehiculoSeleccionado;
        }
    }
};
</script>
<style scoped>
.banner-destacado {
    /* En lugar de 100%, le damos un alto fijo o máximo */
    height: 420px;
    /* Esta altura suele alinear bien con 4 mini-cards + gaps */
    position: relative;
    width: 100%;
}

.banner-destacado img {
    width: 100%;
    height: 100%;
    /* Importante: cover recortará un poco los lados para llenar el alto, 
     contain mostrará la imagen completa pero dejará huecos. */
    object-fit: cover;
    object-position: center;
    /* Centra la parte importante de la pieza */
}

/* Responsivo: En móvil que no sea tan alto */
@media (max-width: 768px) {
    .banner-destacado {
        height: 250px;
        margin-bottom: 1rem;
    }
}

.compatibility-badge-nuevos {
    /* Cambiamos absolute por flex normal para que ocupe su propio lugar */
    display: flex;
    align-items: center;
    gap: 4px;
    background: #f0fff4;
    /* Un verde muy sutil de fondo */
    color: #28a745;
    font-size: 0.65rem;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 4px;
    margin-top: 5px;
    /* Separación de los elementos de arriba */
    margin-bottom: 5px;
    /* Separación del botón Ver detalles */
    border: 1px solid #c6f6d5;
}

/* 2. Capa de degradado: ayuda a la legibilidad del texto */
.text-overlay-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40%;
    /* Solo cubre la parte superior */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
    pointer-events: none;
    /* No interfiere con el clic en el banner */
}

/* 3. Contenedor del texto: position: absolute es clave */
.text-overlay-content {
    position: absolute;
    top: 15px;
    /* Margen superior */
    left: 20px;
    /* Margen izquierdo */
    max-width: 80%;
    /* Para que no se corte en móviles */
    color: white;
    text-align: left;
}

/* Estilo elegante para el texto principal */
.elegant-text {
    font-family: 'Montserrat', sans-serif;
    /* O una letra elegante que uses */
    font-weight: 700;
    font-size: 0.8rem;
    /* Ajuste pequeño y sutil */
    letter-spacing: 2px;
    /* Espaciado entre letras para look de e-commerce de lujo */
    text-transform: uppercase;
}

/* Texto secundario sutil */
.sub-text {
    font-size: 0.65rem;
    font-weight: 400;
    opacity: 0.9;
    letter-spacing: 1px;
}

/* Contenedor del espacio izquierdo */
.hot-deal-placeholder {
    height: 100%;
    min-height: 400px;
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6 !important;
}

/* Tarjeta Mini Estilizada */
.mini-card {
    background: white;
    transition: all 0.3s ease;
    overflow: hidden;
}

.mini-card:hover {
    transform: translateX(-5px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.img-container-mini {
    position: relative;
    /* ¡ESTO ES LO MÁS IMPORTANTE! */
    width: 100%;
    height: 90px;
    /* Altura fija para que todas las mini-cards sean iguales */
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    /* O el color de fondo de tus cards */
    overflow: hidden;
}

.img-mini-fix {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    /* Ajusta la imagen al contenedor sin deformarla */
    padding: 2px;
}

.brand-text {
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--accent-warning, #e67e22);
    text-transform: uppercase;
}

.product-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #06283c;
}

.application-text {
    font-size: 0.7rem;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.btn-view-more {
    font-size: 0.75rem;
    text-decoration: none;
    color: #06283c;
    font-weight: 600;
}

.btn-view-more:hover {
    color: var(--accent-warning, #e67e22);
}

/* Boletín versión mini */
.boletin-mini {
    background: #fdfdfd;
    border-left: 4px solid #cc0000 !important;
}

.mini-pdf-icon {
    width: 35px;
    height: auto;
}

/* Responsive */
@media (max-width: 768px) {
    .hot-deal-placeholder {
        min-height: 250px;
        margin-bottom: 1.5rem;
    }
}
</style>